import { DateTime } from "luxon";

const buildStatusObject = (data, STATUS_MAP) => {
  const BI_MAPPER = {
    is_success: (boolean) => ({ isBiDeployed: String(boolean) }),
    start_timestamp: (timestamp) => ({
      biDeploymentStart: DateTime.fromMillis(timestamp),
    }),
    finish_timestamp: (timestamp) => ({
      biDeploymentFinish: DateTime.fromMillis(timestamp),
    }),
  };

  const DATA_MAPPER = {
    is_success: (boolean) => ({ isDataDeployed: String(boolean) }),
    start_timestamp: (timestamp) => ({
      dataDeploymentStart: DateTime.fromMillis(timestamp),
    }),
    finish_timestamp: (timestamp) => ({
      dataDeploymentFinish: DateTime.fromMillis(timestamp),
    }),
  };

  const SUMMARY_MAPPER = {
    status: (rawStatus) => ({
      rawStatus: rawStatus || "unknown",
      status: STATUS_MAP[rawStatus || "unknown"],
    }),
    message: (string) => ({ message: string }),
    deployment_number: (number) => ({ deploymentNumber: number }),
    start_timestamp: (timestamp) => ({
      licenseDeploymentStart: timestamp ? DateTime.fromMillis(timestamp) : null,
    }),
    finish_timestamp: (timestamp) => ({
      licenseDeploymentFinish: timestamp
        ? DateTime.fromMillis(timestamp)
        : null,
    }),
    last_successful_timestamp: (timestamp) => ({
      licenseLastSuccessfulDeployment: timestamp
        ? DateTime.fromMillis(timestamp)
        : null,
    }),
  };

  const defaultObject = {
    rawStatus: "unknown",
    status: STATUS_MAP["unknown"],
  };

  const biObject = data.bi
    ? Object.keys(data.bi).reduce((object, key) => {
        if (BI_MAPPER[key]) {
          return {
            ...object,
            ...BI_MAPPER[key](data.bi[key]),
          };
        }

        return object;
      }, {})
    : {};

  const dataObject = data.rows
    ? Object.keys(data.rows).reduce((object, key) => {
        if (DATA_MAPPER[key]) {
          return {
            ...object,
            ...DATA_MAPPER[key](data.rows[key]),
          };
        }

        return object;
      }, {})
    : {};

  const licenseObject = data
    ? Object.keys(data).reduce((object, key) => {
        if (SUMMARY_MAPPER[key]) {
          return {
            ...object,
            ...SUMMARY_MAPPER[key](data[key]),
          };
        }

        return object;
      }, {})
    : {};

  return {
    ...defaultObject,
    ...biObject,
    ...dataObject,
    ...licenseObject,
    jsonData: licenseObject,
  };
};

export default buildStatusObject;
